<template functional>
  <div v-if="props.receipt" class="my-3">
    <v-btn
      icon
      :disabled="props.receiptStatus == 'GENERATING'"
      :loading="props.receiptStatus == 'GENERATING'"
      :href="$options.url + props.receipt.pdfFilePath"
      target="_blank"
      download="receipt.pdf"
    >
      <template v-if="props.downloadText"> Download </template>
      <template v-else-if="props.receipt.receiptType.includes('TO_FEDERATION')">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon v-bind="attrs" :large="large" color="primary" v-on="on"
              >$iconReceipt</v-icon
            >
          </template>
          <span>{{ parent.$t("wallet:receiptLink.TO_FEDERATION") }}</span>
        </v-tooltip>
      </template>
      <template v-else-if="props.receipt.receiptType.includes('TO_ORGANISER')">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon v-bind="attrs" :large="large" color="green" v-on="on"
              >$iconReceipt</v-icon
            >
          </template>
          <span
            >{{ parent.$t("wallet:receiptLink.TO_ORGANISER") }}
            {{
              props.receipt.recipientOrganisation.shortName ||
              props.receipt.recipientOrganisation.name
            }}</span
          >
        </v-tooltip>
      </template>
      <template v-else>
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <v-icon v-bind="attrs" :large="large" color="black" v-on="on"
              >$iconReceipt</v-icon
            >
          </template>
          <span>{{ parent.$t("wallet:receiptLink.default", "Receipt") }} </span>
        </v-tooltip>
      </template>
    </v-btn>
  </div>
</template>
<script>
import gql from "fraql";

export default {
  name: "AppReceiptLink",
  props: {
    receiptStatus: {
      type: String,
      default: "GENERATED"
    },
    receipt: {
      type: Object,
      required: true
    },
    downloadText: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  url: process.env.VUE_APP_API_URL,
  fragments: {
    receipt: gql`
      fragment _ on Receipt {
        id
        receiptType
        pdfFilePath
        recipientOrganisation {
          id
          name
          shortName
        }
      }
    `
  }
};
</script>
<style scoped>
a {
  color: var(--v-accent-base) !important;
  text-decoration: underline !important;
}
</style>
